import React, { useMemo, useCallback } from 'react'
import MaterialReactTable from 'material-react-table';
import {
    Typography,
    Box,
    Button,
    IconButton,
    Tooltip,
} from '@mui/material';
//Import Material React Table Translations
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { grey } from '@mui/material/colors';
import { darken, useTheme, createTheme, ThemeProvider } from '@mui/material';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Delete, Edit } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ModalConfirmacion from '../modales/ModalConfirmacion';
import { useNavigate } from 'react-router-dom';

const TablaAsignaciones = ({ columnas, lineas, handleOpen, acciones = false, funcion, tipo }) => {
    const navigate = useNavigate();
    const [data, setData] = React.useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [pagination, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 5
    });
    const [abrir, setAbrir] = React.useState(false) //modal de confirmacion
    const [texto, setTexto] = React.useState('') //texto que sera la prop para el modal
    const [tipoDeBoton, setTipoDeBoton] = React.useState('')
    const [idAsignacion, setIdAsignacion] = React.useState('')

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        }
    }, [lineas])

    //redireccionar a la pagina
    const handleRedireccion = (row) => {
        
        const id = row.original.id; // Obtener el ID desde los datos de la fila
        if(tipo ==="division"){
            navigate(`/aceptacion-asignacion/${id}`); // Redirigir a la ruta con el ID como parámetro
        }else{
            navigate(`/aceptacion-asignacion-actividades/${id}`)
        }
    }

    //abrir modal confirmación
    const handleOpenModalTable = (row, accion) => {
        var id = row.original.id
        setIdAsignacion(id)
        if (accion === 'Confirmar') {
            setTexto('¿Estás seguro que quieres confirmar esta opción?');
            setTipoDeBoton('confirmar')

        } else if (accion === 'Declinar') {
            setTexto('¿Estás seguro que deseas declinar esta opción?');
            setTipoDeBoton('declinar')
        }
        setAbrir(true);
        // console.log(id)
    }

    //cerrar modal
    const handleCloseModalTable = (confirm, action, id) => {
        if (confirm) {
            // console.log("confirma");
            if (action === 'confirmar') {
                // Acciones correspondientes al confirmar
                // console.log("la persona acepta la asignación", id);
                funcion(id, 100000000)
            } else if (action === 'declinar') {
                // Acciones correspondientes al declinar
                funcion(id, 100000001)
                // console.log("la persona declina la asignación", id);
            }
        } else {
            console.log("cancela la operación");
        }
        setAbrir(false);
    }

    return (
        <>
            <MaterialReactTable
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10],
                }}
                columns={columns}
                data={data}
                muiTablePaperProps={{
                    sx: (theme) => ({
                        borderRadius: '0.55rem',
                        border: darken(theme.palette.background.default, 0.1),
                        bgcolor: darken(theme.palette.primary.dark, 0.1),
                        maxWidth: '1000px',
                        m: 'auto',
                    }),
                }}
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableColumnFilterModes={true}
                enableColumnOrdering={true}
                enableColumnFilters={true}
                enableSorting={true}
                // enableColumnResizing
                columnResizeMode="onChange"
                enablePinning
                enableRowActions={acciones}
                enableStickyHeader
                initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: 'compact', }}
                positionToolbarAlertBanner="bottom"
                localization={MRT_Localization_ES}
                defaultColumn={{
                    maxSize: 400,
                    minSize: 40,
                }}
                renderRowActions={({
                    row
                }) => <div style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '0.7rem',
                    margin: '5px'
                }}>
                        <Tooltip arrow placement="left" title="Ver">
                            <IconButton onClick={() => handleRedireccion(row)}>
                                <VisibilityIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="left" title="Confirmar" >
                            <IconButton onClick={() => handleOpenModalTable(row, 'Confirmar')}>
                                <CheckCircleRoundedIcon color='success' />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="left" title="Declinar" >
                            <IconButton onClick={() => handleOpenModalTable(row, 'Declinar')}>
                                <CancelRoundedIcon color='error' />
                            </IconButton>
                        </Tooltip>
                    </div>} />
            <ModalConfirmacion open={abrir} handleClose={handleCloseModalTable} texto={texto} tipo={tipoDeBoton} id={idAsignacion} />
        </>
    )
}

export default TablaAsignaciones